import { render, staticRenderFns } from "./Tabla.vue?vue&type=template&id=3f6411b7&scoped=true&"
import script from "./Tabla.vue?vue&type=script&lang=ts&"
export * from "./Tabla.vue?vue&type=script&lang=ts&"
import style0 from "./Tabla.vue?vue&type=style&index=0&id=3f6411b7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6411b7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VChip,VDataTable,VIcon,VTooltip})
